import styled, { css, DefaultTheme } from 'styled-components';

export default styled.div`
  ${({ theme }: { theme: DefaultTheme }) => {
  return css`
    height: fit-content;
    .share-panel__container {
      padding: 1.5em 1em;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .share-panel__button {
      width: 100%;
      max-width: 16em;
      margin-top: 2em;
      justify-content: center;
    }
    .share-panel__copied-text {
      display: block;
      margin-top: 0.5em;
      font-weight: 400;
      font-size: 0.875em;
      line-height: 1.5em;
    }
  `;
  }}
`;
